/**
 * PORTED — RO-3-11 / #44304.
 * Origin: `excellent/app/database/import/_client.tsx`.
 *
 * Changes, and only these:
 *   `"use client"`                  -> dropped (inert in this host)
 *   `DataImportClient` from `@/data-import/client`
 *                                   -> the RO-3-00 port in `client/shared/`
 *
 * The second is the contract `client/shared/index.ts` publishes: the shared layer
 * is ported once and a section item imports it rather than re-porting. Its origin
 * (`excellent/src/data-import/client.tsx`) is reached from six sections, which is
 * exactly why it lives there and not here.
 *
 * ⚠️ RUNTIME-BLOCKED, code-complete — inherited, not introduced. The ported
 * `DataImportClient` drives `dataImport.preview` and `dataImport.run`, and neither
 * is mounted on the Hono host (grep: zero `mount(app, dataImport…)`). This hub's
 * target grid renders and the picker works; picking a target and previewing a file
 * 404s until L1 ports the `/api/data-import/*` namespace. That is recorded in
 * `docs/rollover/inventory/shared-render.md` §6 and in the shared file's own
 * header, and it is not this item's to fix: mounting another namespace's endpoints
 * is an L1 job, and hand-rolling a substitute would violate CLAUDE.md rule 1.
 */

import { useState } from "react";
import { Button, Card, CardContent } from "@excellent/ui";
import { listImportTargets } from "@excellent/ui/blocks/data-import/targets";
import { DataImportClient } from "../../shared";

export function ImportHub() {
  const [kind, setKind] = useState<string | null>(null);
  const targets = listImportTargets();

  if (kind) {
    const target = targets.find((t) => t.kind === kind);
    return (
      <div className="flex flex-col gap-4">
        <div>
          <Button variant="ghost" size="sm" onClick={() => setKind(null)}>
            ← All imports
          </Button>
        </div>
        {target ? (
          <div className="type-body text-muted-foreground">
            <span className="text-foreground">{target.title}.</span> {target.blurb}
          </div>
        ) : null}
        <DataImportClient targetKind={kind} />
      </div>
    );
  }

  return (
    <div className="grid gap-3 sm:grid-cols-2">
      {targets.map((t) => (
        <Card key={t.kind} interactive asChild>
          <button type="button" onClick={() => setKind(t.kind)} className="text-left">
            <CardContent>
              <div className="type-body text-foreground">{t.title}</div>
              <div className="mt-1 type-body text-muted-foreground">{t.blurb}</div>
            </CardContent>
          </button>
        </Card>
      ))}
    </div>
  );
}
